import type { Analytics } from "firebase/analytics";
import type { FirebaseApp } from "firebase/app";
import type { FirebasePerformance } from "firebase/performance";

const firebaseConfig = {
    apiKey: "AIzaSyDjTEydGYCo2Jpenag7X43wpFqkL1ipPLc",
    authDomain: "marhaf-chamie.firebaseapp.com",
    projectId: "marhaf-chamie",
    storageBucket: "marhaf-chamie.firebasestorage.app",
    messagingSenderId: "895683313818",
    appId: "1:895683313818:web:921538ecedc27e950a1f23",
    measurementId: "G-0TP76JNT5K",
};

let firebaseApp: FirebaseApp | null = null;
let analytics: Analytics | null = null;
let performance: FirebasePerformance | null = null;

export const initializeFirebase = async () => {
    if (firebaseApp) return { app: firebaseApp, analytics, performance };

    const [{ initializeApp }, { getAnalytics }, { getPerformance }] = await Promise.all([
        import("firebase/app"),
        import("firebase/analytics"),
        import("firebase/performance"),
    ]);

    firebaseApp = initializeApp(firebaseConfig);
    analytics = getAnalytics(firebaseApp);
    performance = getPerformance(firebaseApp);

    return { app: firebaseApp, analytics, performance };
};
